function getHashParams(hash: string): URLSearchParams {
  const value = hash.startsWith('#') ? hash.slice(1) : hash;
  return new URLSearchParams(value);
}

function hasOAuthPair(params: URLSearchParams): boolean {
  const state = params.get('state');

  if (!state) {
    return false;
  }

  return Boolean(params.get('code') || params.get('error') || params.get('access_token'));
}

export function hasOAuthCallbackParams(urlString: string = window.location.href): boolean {
  const url = new URL(urlString);

  return hasOAuthPair(url.searchParams) || hasOAuthPair(getHashParams(url.hash));
}
